import React from "react";
import { withStyles } from "@material-ui/styles";
import Accordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Icon } from '@iconify/react';
import { Box } from "@material-ui/core";
import { useState } from "react";
import DialPadDtmf from "./DialPadDtmf";

const styles = (theme) => ({
    root: {
        width: "100%"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular
    }
});

const AccordionSummary = withStyles({
    root: {
        flexDirection: "column"
    },
    content: {
        marginBottom: 0
    },
    expandIcon: {
        paddingTop: 0
    },
})(MuiAccordionSummary);

export default function ExpandDialPadDtmf() {
    const [openDialPad, setOpenDialPad] = useState(false);
    const hanldeDialPad = () => {
        setOpenDialPad(!openDialPad);
    }
    return (
        <>
            <Accordion sx={{ width: 200, backgroundColor: "transparent" }}>
                <AccordionSummary
                    // expandIcon={<Icon icon="ph:caret-circle-down-light" width="40" />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Box sx={{ borderRadius: '50%', borderBottom: 1, pl: 3, pr: 3, borderColor: 'white' }} onClick={() => hanldeDialPad()}>
                        {/* <Typography variant="h6" color={"white"}>Phím Số</Typography> */}
                        <Icon icon={openDialPad ? "tabler:dialpad-off" : "tabler:dialpad"} width="36" color="white" />
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <DialPadDtmf />
                </AccordionDetails>
            </Accordion>
        </>
    );
}
